import { supabase } from '@/lib/supabase'
import { safeRandomUUID } from '@/lib/utils'

type AnalyticsEvent = {
  event_type: string
  event_properties?: Record<string, unknown>
  session_id: string
  device_info?: Record<string, unknown>
  location_data?: Record<string, unknown>
  client_timestamp?: string
}

export interface ViewStats {
  globalViews: number
  institutionViews: number
  moduleViews: number
}

function getOrCreateSessionId(): string {
  const key = 'analytics_session_id'
  try {
    const existing = sessionStorage.getItem(key)
    if (existing) return existing
    const id = safeRandomUUID()
    sessionStorage.setItem(key, id)
    return id
  } catch {
    return safeRandomUUID()
  }
}

function getDeviceInfo(): Record<string, unknown> {
  const nav = navigator as any
  return {
    ua: navigator.userAgent,
    platform: nav.platform || null,
    language: navigator.language,
    languages: navigator.languages || [],
    viewport: { w: window.innerWidth, h: window.innerHeight, dpr: window.devicePixelRatio || 1 },
    tz: Intl.DateTimeFormat().resolvedOptions().timeZone || null,
  }
}

export async function trackAnalyticsEvent(event_type: string, event_properties?: Record<string, unknown>) {
  const payload: AnalyticsEvent = {
    event_type,
    event_properties: event_properties || {},
    session_id: getOrCreateSessionId(),
    device_info: getDeviceInfo(),
    location_data: { tz: Intl.DateTimeFormat().resolvedOptions().timeZone || null },
    client_timestamp: new Date().toISOString(),
  }

  const { error } = await supabase.functions.invoke('analytics-ingest', { body: payload })
  if (error) throw error
}
